import { UNIQUE_DOWNLOADS_KEY } from '../../local-storage/constants';
import { getStorageItem, setStorageItem } from '../../local-storage/local-storage';

export function plariumPlayDownloadStarted() {
  const data = getStorageItem(UNIQUE_DOWNLOADS_KEY, [] as string[]);

  const downloadedBefore = data.find((i: string) => i === window.location.href);
  if (downloadedBefore) {
    return;
  }

  data.push(window.location.href);
  setStorageItem(UNIQUE_DOWNLOADS_KEY, data);
}
